import {isProductionHost} from '@albert-io/environment';

declare global {
  interface Window {
    Intercom: any;
  }
}

const canUseIntercom = () => isProductionHost() && typeof window.Intercom === 'function';

export const setIntercomAlignment = (alignment: 'left' | 'right') => {
  if (canUseIntercom()) {
    window.Intercom('update', {alignment});
  }
};

/**
 * Opens the messenger with `message` prefilled as an unsent draft. No-ops wherever Intercom never
 * boots (narrow viewports, blockers, non-production hosts), so keep a non-chat contact route
 * beside any trigger.
 */
export const showIntercomNewMessage = (message: string) => {
  if (canUseIntercom()) {
    window.Intercom('showNewMessage', message);
  }
};
